import './App.css';
import './lib/i18n';
import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import {Toaster} from 'sonner';
import {Layout} from './components/Layout';
import {AuthProvider, Protected} from './components/AuthContext';
import Home from './pages/Home';
import {Company, Thesis, Products, ProductDetail, Governance, Privacy, NotFound} from './pages/PublicPages';
import Book from './pages/Book';
import Progress from './pages/Progress';
import Introduction from './pages/Introduction';
import GuestInvest from './pages/GuestInvest';
import GuestInterestsAdmin from './pages/GuestInterestsAdmin';
import Auth from './pages/Auth';
import Portal from './pages/Portal';
import Admin from './pages/Admin';
import Register from './pages/Register';
import FounderSetup from './pages/FounderSetup';
import Invitation from './pages/Invitation';
import InvestorAccounts from './pages/InvestorAccounts';
import {AccountOrigin} from './components/AccountOrigin';
import Preseed from './pages/Preseed';
import PreseedAdmin from './pages/PreseedAdmin';
import MeetingsAdmin from './pages/MeetingsAdmin';

export default function App() {
  return <BrowserRouter><AuthProvider><Layout><Routes>
    <Route path="/" element={<Home/>}/><Route path="/company" element={<Company/>}/>
    <Route path="/thesis" element={<Thesis/>}/><Route path="/products" element={<Products/>}/>
    <Route path="/products/:id" element={<ProductDetail/>}/><Route path="/book" element={<Book/>}/>
    <Route path="/progress" element={<Progress/>}/><Route path="/governance" element={<Governance/>}/>
    <Route path="/privacy" element={<Privacy/>}/><Route path="/investor-relations" element={<Introduction/>}/>
    <Route path="/preseed" element={<Preseed/>}/><Route path="/pre-seed" element={<Navigate to="/preseed" replace/>}/>
    <Route path="/invest" element={<GuestInvest/>}/><Route path="/login" element={<AccountOrigin><Auth/></AccountOrigin>}/>
    <Route path="/register" element={<AccountOrigin><Register/></AccountOrigin>}/><Route path="/founder" element={<AccountOrigin><Auth founder/></AccountOrigin>}/>
    <Route path="/accept-invitation" element={<AccountOrigin><Invitation/></AccountOrigin>}/><Route path="/invite/:token" element={<AccountOrigin><Invitation/></AccountOrigin>}/>
    <Route path="/admin/setup" element={<AccountOrigin><FounderSetup/></AccountOrigin>}/>
    <Route path="/portal/*" element={<AccountOrigin><Protected><Portal/></Protected></AccountOrigin>}/>
    <Route path="/admin/guest-interests" element={<AccountOrigin><Protected admin><GuestInterestsAdmin/></Protected></AccountOrigin>}/>
    <Route path="/admin/accounts" element={<AccountOrigin><Protected admin><InvestorAccounts/></Protected></AccountOrigin>}/>
    <Route path="/admin/preseed" element={<AccountOrigin><Protected admin><PreseedAdmin/></Protected></AccountOrigin>}/>
    <Route path="/admin/meetings" element={<AccountOrigin><Protected admin><MeetingsAdmin/></Protected></AccountOrigin>}/>
    <Route path="/admin/*" element={<AccountOrigin><Protected admin><Admin/></Protected></AccountOrigin>}/>
    <Route path="*" element={<NotFound/>}/>
  </Routes></Layout><Toaster position="bottom-right" richColors closeButton/></AuthProvider></BrowserRouter>;
}